import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  HCheckbox,
  HDatePicker,
  HInput,
  HRadio,
} from "../../../../validation/HForm";
import { FormSection } from "./FormSection";

const PensionerSection = ({ questionNumber }) => {
  const { control } = useFormContext();
  const isPensioner = useWatch({ control, name: "isPensioner" });
  const isIncomeConfirmed = useWatch({ control, name: "isPensionConfirmed" });
  const showPensionInfo = isPensioner === "Да";

  return (
    <FormSection
      questionNumber={questionNumber}
      title="Клиент является пенсионером по возрасту?"
    >
      <div className="d-flex columns-2">
        <HRadio
          labels={["Да", "Нет"]}
          name="isPensioner"
          checkboxStyle={true}
        />
      </div>

      {showPensionInfo && (
        <div>
          <label className="form-element-label">
            Укажите общую сумму пенсии
          </label>
          <div>
            <HInput
              className="input fullwidth"
              type="text"
              name="monthlyPension"
              autoComplete="off"
              decimals={2}
              placeholder=".руб"
            />
          </div>

          <div className="m-t-spacer">
            <HCheckbox
              name="isPensionConfirmed"
              className="input"
              label="Доход подтверждён"
            />
          </div>

          {isIncomeConfirmed && (
            <div className="d-flex columns-2">
              <div className="flex-1">
                <label className="form-element-label">Номер документа</label>
                <div>
                  <HInput
                    className="input fullwidth"
                    type="text"
                    name="pensionIncomeDoc.incomeDocNumber"
                  />
                </div>
              </div>
              <div className="flex-1">
                <label className="form-element-label">Дата документа</label>
                <div>
                  <HDatePicker
                    h="true"
                    className="input fullwidth"
                    name="pensionIncomeDoc.incomeDocDate"
                  />
                </div>
              </div>
              <div>
                <HInput
                  type="hidden"
                  name="pensionIncomeDoc.monthlyIncome"
                  autoComplete="off"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </FormSection>
  );
};

export default PensionerSection;
